import React, { useState } from 'react';

// Interface for field data
interface FieldData {
  label: string;
  value: string;
}

interface PanelDangerTextBoxProps {
  fields: FieldData[];
}

const CopyIcon: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" 
      fill="currentColor"
      stroke="rgba(255,255,255,0.2)"
      strokeWidth="0.5"
    />
  </svg>
);

const PanelDangerTextBox: React.FC<PanelDangerTextBoxProps> = ({ fields = [] }) => {
  // Only use the fields parameter
  const fieldsToRender = fields;

  // Track copied state for each field by index
  const [copiedStates, setCopiedStates] = useState<boolean[]>(Array(fieldsToRender.length).fill(false));

  const copyToClipboard = (text: string, index: number) => {
    navigator.clipboard.writeText(text);
    
    // Update just the specific index that was copied
    setCopiedStates(prev => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });
    
    // Reset the copied state after 2 seconds
    setTimeout(() => {
      setCopiedStates(prev => {
        const newState = [...prev];
        newState[index] = false;
        return newState;
      });
    }, 2000);
  };

  return (
    <div className="panel-danger-text-box">
      <div className="danger-content panel-danger-text-content">
        {fieldsToRender.map((field, index) => (
          <div key={`field-${index}`} className="danger-field">
            <div className="danger-field-header">
              <span className="danger-label">{field.label}</span>
            </div>
            <div className="danger-value">
              {field.value}
              <button 
                className="copy-icon-btn" 
                onClick={() => copyToClipboard(field.value, index)}
                title={`Copy ${field.label}`}
              >
                <CopyIcon />
                {copiedStates[index] && <span className="copy-tooltip">Copied!</span>}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PanelDangerTextBox;
